import { UnitTransferSigningModeEnumType } from '__generated__/graphql';

export default function unitTransferSigningModeToReadable(mode: UnitTransferSigningModeEnumType): {
  label: string;
  color: string;
} {
  switch (mode) {
    case UnitTransferSigningModeEnumType.Digital:
      return { label: 'Digital (E-Sign)', color: 'sky' };
    case UnitTransferSigningModeEnumType.Manual:
      return { label: 'Manual', color: 'purple' };
    default:
      return { label: mode, color: 'gray' };
  }
}
